module.exports = __webpack_public_path__ + "img/kehu_5@2x.cc8c58a1.png";